import { __decorate } from "tslib";
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfDocentsFrontendAdminFeature = /*#__PURE__*/(() => {
  let MpfDocentsFrontendAdminFeature = class MpfDocentsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/docents/frontend-admin","featureId":"mpf-docents"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Dozenten',
          priority: 5,
          routerLink: 'docents/docents',
          icon: 'chalkboard-teacher'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfDocentsFrontendAdminFeature_BaseFactory;
        return function MpfDocentsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMpfDocentsFrontendAdminFeature_BaseFactory || (ɵMpfDocentsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfDocentsFrontendAdminFeature)))(__ngFactoryType__ || MpfDocentsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfDocentsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'docents',
          loadChildren: () => import('./docents-admin.module').then(m => m.DocentsFrontendAdminModule)
        }])]
      });
    }
  };
  MpfDocentsFrontendAdminFeature = __decorate([ClassName("MpfDocentsFrontendAdminFeature")], MpfDocentsFrontendAdminFeature);
  return MpfDocentsFrontendAdminFeature;
})();
export { MpfDocentsFrontendAdminFeature };